import { AlertOutputWithStatus } from './alert-output-with-status.model';


export class AlertSelectByIdOutput implements IAlertSelectByIdOutput {
    status!: number;
    message!: string;
    data!: AlertOutputWithStatus;

    constructor(data?: IAlertSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? AlertOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AlertSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AlertSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IAlertSelectByIdOutput {
    status: number;
    message: string;
    data: AlertOutputWithStatus;
}

